var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Sad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 24,
    cy: 24,
    r: 18,
    fx: 24.095,
    fy: 16.289,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6de82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#fdda4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ffd53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#fdc434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6a71f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 23.99328,
    cy: 31.71074,
    r: 3.71218,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#f6de82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#ffe16e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 23.98806,
    cy: 32.78824,
    r: 5.11519,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 23.97945,
    cy: 33.54405,
    r: 5.4789,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,19.2) scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.258,24.061c0,0 -1.726,0.944 -3.258,0.944c-1.532,0 -3.258,-0.944 -3.258,-0.944l-0.631,0.754c0,0 1.765,2.185 3.889,2.185c2.124,0 3.889,-2.185 3.889,-2.185z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.258,24.061c0,0 -1.726,0.944 -3.258,0.944c-1.532,0 -3.258,-0.944 -3.258,-0.944l-0.631,0.754c0,0 1.765,2.185 3.889,2.185c2.124,0 3.889,-2.185 3.889,-2.185z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.457,19.998c-0.827,-0.044 -1.607,-0.148 -2.403,-0.292c-0.792,-0.146 -1.578,-0.339 -2.357,-0.584c-1.551,-0.501 -3.088,-1.233 -4.413,-2.402c-0.422,-0.372 -0.462,-1.015 -0.09,-1.437c0.372,-0.422 1.015,-0.462 1.437,-0.09c0.029,0.026 0.056,0.052 0.081,0.08l0.006,0.007c0.916,1.013 2.161,1.819 3.517,2.425c1.356,0.598 2.841,1.047 4.309,1.297l0.024,0.004c0.272,0.047 0.455,0.305 0.409,0.577c-0.044,0.253 -0.27,0.429 -0.52,0.415z",
    fill: "#805b2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.457,19.002c1.468,-0.251 2.953,-0.7 4.309,-1.297c1.356,-0.606 2.602,-1.412 3.517,-2.425l0.005,-0.006c0.377,-0.417 1.021,-0.45 1.438,-0.073c0.417,0.377 0.45,1.021 0.073,1.438c-0.026,0.029 -0.054,0.056 -0.082,0.081c-1.326,1.169 -2.863,1.901 -4.413,2.402c-0.779,0.245 -1.566,0.439 -2.357,0.584c-0.796,0.144 -1.577,0.248 -2.403,0.292c-0.276,0.015 -0.511,-0.197 -0.526,-0.473c-0.014,-0.256 0.168,-0.477 0.415,-0.519z",
    fill: "#805b2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.17,34.252c0,0 1.116,0.748 4.83,0.748c3.44,0 4.827,-0.748 4.827,-0.748c0,0 -0.863,-1.485 -4.827,-1.485c-3.964,0 -4.83,1.485 -4.83,1.485z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,34c3.392,0 4.31,0.609 4.31,0.609c0,0 -0.88,1.391 -4.31,1.391c-3.43,0 -4.31,-1.391 -4.31,-1.391c0,0 0.918,-0.609 4.31,-0.609z",
    fill: "url(#color-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.701,34.195c0.501,0.276 0.995,-0.358 0.608,-0.779c-1.124,-1.222 -2.851,-2.416 -5.309,-2.416c-2.458,0 -4.185,1.194 -5.309,2.416c-0.387,0.421 0.107,1.055 0.608,0.779c1.151,-0.636 2.725,-1.195 4.701,-1.195c1.976,0 3.55,0.559 4.701,1.195z",
    fill: "url(#color-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Sad);
export default __webpack_public_path__ + "static/media/icons8-sad.0968f60a925adf15aced2ac79f75ad10.svg";
export { ForwardRef as ReactComponent };